import React from 'react';
import { Textarea } from '@/components/ui/textarea';

interface TextareaFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  placeholder?: string;
  error?: string;
  rows?: number;
}

export const TextareaField: React.FC<TextareaFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error,
  rows = 3
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <Textarea
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={error ? 'border-red-500 focus:border-red-500' : ''}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </>
  );
};
